// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__Wuwx3","primary":"button_primary__0mQ2L","danger":"button_danger__YOzne"};